import  EditPageSortableList from './EditPageSortableList';


export {  EntityName } from './EditPageSortableItem';
export { EntityType } from './EditPageSortableItem';
export { EntityDesciption } from './EditPageSortableItem';
export default EditPageSortableList;



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/EditPageCommon/EditPageSortableList/index.jsx